import { SubtasksManager } from './subtasks-manager/subtasks-manager.component';

export default angular
  .module('sfMobile.components.subtasks', ['sfMobile.services.localization'])
  .component('sfSubtasksManager', SubtasksManager).name;
